export default __webpack_public_path__ + "static/media/MAGStarDeployments_2023_map.5d894371.png";